import { BORDER, COLOR, FONT, GTR } from '@farewill/ui/tokens'
import styled from 'styled-components'

export type PriceRowAttributes = {
  name: string
  price: string
  quantity?: number
}

const StyledContainer = styled.div`
  border: 1px solid ${COLOR.BACKGROUND.SMOKE};
  border-radius: ${BORDER.RADIUS.S};
  overflow: hidden;
`

const StyledHeader = styled.div<{ $isDisabled: boolean }>`
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? COLOR.BACKGROUND.SMOKE : COLOR.ACCENT.PRIMARY_60};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${GTR.S} ${GTR.M};
  font-weight: ${FONT.WEIGHT.MEDIUM};
  font-size: ${FONT.SIZE.M};
  color: ${COLOR.BLACK};
`

const StyledVersion = styled.span`
  font-weight: ${FONT.WEIGHT.REGULAR};
  font-size: ${FONT.SIZE.S};
`

const StyledRow = styled.div<{ $isOdd: boolean }>`
  background-color: ${({ $isOdd }) =>
    $isOdd ? COLOR.BACKGROUND.FOG : COLOR.WHITE};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${GTR.XS} ${GTR.M};
`

const StyledItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${GTR.XS};
`

const StyledItemName = styled.span`
  font-size: ${FONT.SIZE.M};
  color: ${COLOR.GREY.DARK};
`

export const StyledPrice = styled.span`
  font-size: ${FONT.SIZE.M};
  font-weight: ${FONT.WEIGHT.BOLD};
  color: ${COLOR.GREY.DARK};
`

const StyledQuantity = styled.div`
  width: 80px;
  text-align: center;
  font-size: ${FONT.SIZE.M};
  color: ${COLOR.BLACK};
`

export const PriceTable = ({
  rows,
  withQuantity = false,
  title,
  isDisabled = false,
  version,
}: {
  rows: PriceRowAttributes[]
  withQuantity?: boolean
  title: string
  isDisabled?: boolean
  version?: string
}) => {
  return (
    <StyledContainer>
      <StyledHeader $isDisabled={isDisabled}>
        <span>
          {title}
          {version && (
            <StyledVersion>
              {' '}
              (version: {version.replaceAll('_', '-')})
            </StyledVersion>
          )}
        </span>
        {withQuantity && <StyledQuantity>Quantity</StyledQuantity>}
      </StyledHeader>
      {rows.map((item, index) => (
        <StyledRow key={item.name} $isOdd={index % 2 === 1}>
          <StyledItemDetails>
            <StyledItemName>{item.name}</StyledItemName>
            <StyledPrice>{item.price}</StyledPrice>
          </StyledItemDetails>
          {withQuantity && <StyledQuantity>{item.quantity}</StyledQuantity>}
        </StyledRow>
      ))}
    </StyledContainer>
  )
}
